import { useEffect, useState } from "react";
import metaDataServices from "../MetaDataServices";
import Drawer from 'react-modern-drawer';
import Production_listing from "./production_listing";


export default function CueSerieUpsert(param: any) { 

    let [isOpen, setIsOpen] = useState(param.cueOpen);
    let [productSelect, setProductSelect] = useState(false);
    let [cueUpsertData, SetcuelUpsertData] = useState<any>([]);
    let [showCueSuccessSaveMsg, setshowCueSuccessSaveMsg] = useState(false);

    const onCloseDrawer = () => {
        param.onChange();
        isOpen = false;
        setIsOpen(isOpen)
    }

    useEffect(() => {
        cueUpsertData = param.cueUpsert
        SetcuelUpsertData(cueUpsertData)

    }, [param.cueUpsert])

    const resetCueUpsertForm = () => {
        cueUpsertData = [];
        SetcuelUpsertData(cueUpsertData)
    }

    const saveCueUpsertForm = () => {
        console.log(cueUpsertData)
        metaDataServices.cueSeriesSave(cueUpsertData).then((res:any) => {

            setshowCueSuccessSaveMsg(true)
            setTimeout(function () {
                setshowCueSuccessSaveMsg(false);
            }, 3000);
        })
    }

    const productSelection = (e: any) => {
        productSelect = false
        setProductSelect(productSelect)
    }

    return (<>
        <Drawer open={isOpen}
            onClose={() => setIsOpen(false)}
            direction='right'
            className='react-drawer allowHscroll allowVscroll'
            size={800}>
            <div className="box noBorderRadius noBorder ws-6 pull-right">

                <div className="box-header  noBorderRadius bg-blue pLarge">
                    Add/Edit Cue
                </div>

                <div className="ws-12 pm ">

                    {showCueSuccessSaveMsg && <div className="alert alert-success">Cue saved successfully  </div>}

                    <div className="ws-12">

                        <div className="ws-6 pm">
                            <label className="ws-12 text-bold">Production Id</label>
                            <input className="form-control w-77" id="productionId" name="productionId" type="text" placeholder="Production Id" />
                            <button className="icon-btn info height30 width90 pull-right" onClick={() => setProductSelect(true)}> Select</button>
                        </div>

                        <div className="ws-6 pm">
                            <label className="ws-12 text-bold">Cue Sheet Type</label>
                            <select name="cueSheetType " className="ws-12">
                                <option value="">Choose cue sheet type</option>
                                {global?.cueSheetType?.map((values: any) => {
                                    return (<option className="width200">{values?.cueSheetTypeDesc}</option>)
                                })}
                            </select>
                        </div>

                        <div className="ws-6 pm">
                            <label className="ws-12 text-bold">Series Name</label>
                            <input className="ws-12" id="seriesName" name="seriesName" type="text" placeholder="Series Name" />
                        </div>

                        <div className="ws-6 pm">
                            <label className="ws-12 text-bold">Series Production Number</label>
                            <input className="ws-12" id="seriesProductionNum" name="seriesProductionNum" type="text" placeholder="Series Production Number" />
                        </div>

                        <div className="ws-6 pm">
                            <label className="ws-12 text-bold">Series Category</label>
                            <input className="ws-12" id="seriesCategory" name="seriesCategory" type="text" placeholder="Series Category" />
                        </div>

                        <div className="ws-6 pm">
                            <label className="ws-12 text-bold">Series Version</label>
                            <input className="ws-12" id="seriesVersion" name="seriesVersion" type="text" placeholder="Series Version" />
                        </div>

                        <div className="ws-6 pm">
                            <label className="ws-12 text-bold">Series Language</label>
                            <input className="ws-12" id="seriesLanguage" name="seriesLanguage" type="text" placeholder="Series Language" />
                        </div>

                        <div className="ws-6 pm">
                            <label className="ws-12 text-bold">Series Duration</label>
                            <input className="w-49 text-right" id="seriesDurationMinute" name="seriesDurationMinute" type="text" placeholder="Minutes" />
                            <input className="w-49 text-right ml" id="seriesDurationSecond" name="seriesDurationSecond" type="text" placeholder="Seconds" />
                        </div>

                        <div className="ws-6 pm">
                            <label className="ws-12 text-bold">Series Comments</label>
                            <textarea className="ws-12" id="seriesComments" name="seriesComments" placeholder="Series Comments"></textarea>
                        </div>

                        <div className="ws-6 pm">
                            <label className="ws-12 text-bold">Series Instructions</label>
                            <textarea className="ws-12" id="seriesInstructions" name="seriesInstructions" placeholder="Series Instructions"></textarea>
                        </div>

                    </div>

                </div>

                {
                    (() => {
                        if (productSelect) {
                            return <Production_listing onChange={productSelection} productSelect={productSelect} />
                        }

                    })()
                }

                <div className="ws-12 pm ">
                    <button type="button" className="icon-btn delete pull-right" onClick={() => onCloseDrawer()}>x Close</button>
                    <button type="button" className="icon-btn delete pull-right" onClick={() => resetCueUpsertForm()}>↻ Reset</button>
                    <button type="button" className="icon-btn edit pull-right" onClick={() => saveCueUpsertForm()}>✔ Save</button>
                </div>
            </div>

        </Drawer>
    </>)
}